import { Component, Input, OnInit } from '@angular/core';
import { AppServiceService } from 'src/app/app-service.service';
import { Customer, Unit, UserDetailsMainModel } from 'src/app/user-details-model';

@Component({
  selector: 'app-gis-mini-map',
  templateUrl: './gis-mini-map.component.html',
  styleUrls: ['./gis-mini-map.component.scss']
})
export class GisMiniMapComponent implements OnInit {

  @Input('blastId') blastId: string = '';
  @Input('showSelectionChange') showSelectionChange: boolean = false;
  userDetails: UserDetailsMainModel;
  selectedCustomer: Customer;
  selectedUnit: Unit;
  constructor(
    private appService: AppServiceService,

  ) { }

  ngOnInit(): void {
    this.appService.userDetails.subscribe((d) => (this.userDetails = d));
    this.appService.selectedCustomer.subscribe(
      (d) => (this.selectedCustomer = d)
    );
    this.appService.selectedUnit.subscribe((d) => (this.selectedUnit = d));
    
        import("mine_map_lite/MapBootstrap")
      .then((map) => {
        map.default("mine_map_lite", { blastId: this.blastId ,unit_id: this.selectedUnit.platformUnitId, showSelectionChange : this.showSelectionChange });
      })
      .catch((err) => {
        console.error(err);
      });
  }

}
